import _extends from "@babel/runtime/helpers/extends";
import { RuleElement } from '@wix/rules-panel-ui';
import React, { useCallback } from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useHandleElementClick } from '../../../hooks/use-handle-element-click';
import { getRuleElementPropsFromCapabilities } from '../../../utils/get-fixer-design-props';
import { MediaAlternativesRuleContent } from './media-alternatives-rule-content/media-alternatives-rule-content';
import { MediaAlternativesRuleHeader } from './media-alternatives-rule-header/media-alternatives-rule-header';
export const MediaAlternativesRule = _ref => {
  let {
    status,
    isOpen,
    toggleElement,
    showLoader,
    elementIndex,
    id,
    contentRef,
    headerRef,
    type,
    title,
    onClickApply,
    onClickCancel,
    disabled = false,
    uri,
    sourceType
  } = _ref;
  const biLogger = useBiLogger();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const ruleElementProps = getRuleElementPropsFromCapabilities(capabilities);
  const sessionStatus = status;
  const isLoading = showLoader;
  const onStatusChange = useCallback(() => {
    biLogger.elementStatusChange({
      index: elementIndex,
      status,
      value: undefined
    });
  }, [biLogger, elementIndex, status]);
  const {
    handleClickElement
  } = useHandleElementClick({
    isOpen,
    onOpenElement: () => biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.Edit,
      index: elementIndex,
      status
    }),
    toggleElement
  });
  return /*#__PURE__*/React.createElement(RuleElement, _extends({
    contentComponent: /*#__PURE__*/React.createElement("div", {
      ref: contentRef
    }, /*#__PURE__*/React.createElement(MediaAlternativesRuleContent, {
      index: elementIndex,
      showLoader: showLoader,
      status: status,
      type: type,
      onClickApply: onClickApply,
      onClickCancel: onClickCancel
    })),
    disabled: disabled,
    headerComponent: /*#__PURE__*/React.createElement("div", {
      ref: isOpen ? headerRef : null
    }, /*#__PURE__*/React.createElement(MediaAlternativesRuleHeader, {
      disabled: disabled,
      id: id,
      index: elementIndex,
      isLoading: isLoading,
      sourceType: sourceType,
      status: sessionStatus,
      title: title,
      uri: uri
    })),
    id: id,
    isOpen: isOpen,
    status: sessionStatus
  }, ruleElementProps, {
    onClick: () => {
      handleClickElement();
    },
    onStatusChange: onStatusChange
  }));
};
//# sourceMappingURL=media-alternatives-rule.js.map